import React, { useEffect, useState } from 'react'
import { MenuItem, Select, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import Skeleton from 'react-loading-skeleton'
import { useFilter } from '../../../app/contexts/FilterContextProvider'
import { DuplicateImagesModal } from './DuplicateImagesModal'
import LoadingSpinner from '../../../components/common/LoadingSpinner'
import { EmptyFolderIcon } from '../../../components/svgs/Svgs'

export function DuplicatedImages({ entites, loading, startDate, endDate }) {
    const { analyticsFilter, setAnalyticsFilter } = useFilter()
    const [selectedHistory, setSelectedHistory] = useState(() => {
        const saved = localStorage.getItem('duplicateSelectedHistory')
        return saved ? JSON.parse(saved) : []
    })

    useEffect(() => {
        localStorage.setItem('duplicateSelectedHistory', JSON.stringify(selectedHistory))
    }, [selectedHistory])

    const entitiesOptions = entites?.length
        ? entites.map((e) => ({ value: e.tenantEntityId, label: e.mttName, id: e.mttId }))
        : []

    const handleChange = (e) => {
        const newValue = e.target.value
        setAnalyticsFilter({ duplicateId: newValue })
        setSelectedHistory((prev) => (prev.includes(newValue) ? prev : [...prev, newValue]))
    }

    const handleClear = () => {
        setAnalyticsFilter({ duplicateId: '' })
        setSelectedHistory([])
        localStorage.removeItem('duplicateSelectedHistory')
    }

    return (
        <div className="w-[100%] bg-white rounded-[6px] p-[15px] flex flex-col items-start gap-[20px]">
            {loading ? (
                <div className="flex items-center justify-center w-full h-[100px]">
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    <span className="text-[14px] font-[600] text-black">Duplicate Images</span>
                    {entites?.length > 0 ? (
                        <div className="w-full flex items-center justify-between gap-4">
                            <span className="text-[14px] font-[600] text-gray-500">Duplicate Images Entities</span>
                            <span className="text-[14px] font-[600] text-gray-200">{entites?.length}</span>

                            <div className="relative flex items-center gap-2">
                                <Select
                                    variant="outlined"
                                    displayEmpty
                                    renderValue={(value) => (value
                                        ? entitiesOptions.find((v) => v.value === value)?.label
                                        : 'Choose entity')}
                                    sx={{ height: 37, width: '17rem' }}
                                    value={analyticsFilter.duplicateId}
                                    onChange={handleChange}
                                >
                                    {!loading && entites.length ? (
                                        entitiesOptions.map((menuItem) => (
                                            <MenuItem
                                                key={menuItem.value}
                                                value={menuItem.value}
                                                sx={{
                                                    color: selectedHistory.includes(menuItem.value)
                                                        ? 'green'
                                                        : 'inherit',
                                                    fontWeight: selectedHistory.includes(menuItem.value)
                                                        ? 600
                                                        : 'normal',
                                                }}
                                            >
                                                {`${menuItem?.id} ${menuItem?.label}`}
                                            </MenuItem>
                                        ))
                                    ) : loading ? (
                                        <MenuItem>
                                            <Skeleton width="50%" height={30} />
                                        </MenuItem>
                                    ) : (
                                        <MenuItem value="">Nothing Found</MenuItem>
                                    )}
                                </Select>
                                {selectedHistory.length > 0 && (
                                    <IconButton onClick={handleClear} size="small">
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </div>

                            <DuplicateImagesModal
                                entityId={analyticsFilter.duplicateId}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>
                    ) : (
                        <div className="w-full h-auto flex flex-col items-center justify-center">
                            <EmptyFolderIcon />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}
